import SelectorColorLink from '@common/ui/selector/SelectorColorLink';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorSwatch from './ColorSwatch';
const ProductSelectionColorExpandedLinks = (props) => {
    var _a;
    const { t } = useTranslation();
    const linksRef = React.useRef([]);
    const radioGroupId = `select-color-pdp-${props.productUuid || props.currentId}`;
    const handleLinkSelect = (index) => {
        props.onChangeVariation(props.variationValues[index]);
        linksRef.current[index].focus();
    };
    // Manage keyboard navigation, leaving tab key out of this, in order to mockup a radio group behavior
    const handleKeyDown = (e, index) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            const nextIndex = (index + 1) % linksRef.current.length;
            handleLinkSelect(nextIndex);
        }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            const prevIndex = (index - 1 + linksRef.current.length) % linksRef.current.length;
            handleLinkSelect(prevIndex);
        }
        else if (e.key === 'Enter') {
            handleLinkSelect(index);
        }
    };
    return (React.createElement("div", { className: classNames('selector-color-expanded', { inverted: props.inverted }, props.className), "aria-label": t('product.selectcolor') },
        React.createElement("span", { className: "selector__label" },
            React.createElement("span", { className: "selector__label__name" },
                t('label.color'),
                ":"),
            React.createElement("span", { className: "selector__label__value" }, (_a = props.variationValues.find((variationValue) => variationValue.id === props.currentId)) === null || _a === void 0 ? void 0 : _a.displayValue)),
        React.createElement("div", { className: "selector__menu", role: "radiogroup", "aria-labelledby": radioGroupId },
            React.createElement("p", { id: radioGroupId, className: "visually-hidden" }, t('exchanges.changecolor')),
            props.variationValues.map((variation, index) => {
                if (props.hideOnlineExclusive && variation.isOnlineExclusive) {
                    return;
                }
                return (React.createElement(SelectorColorLink, { ref: (el) => (linksRef.current[index] = el), key: variation.id, value: variation.id, label: variation.displayValue, disabled: props.alwaysAvailable || (variation === null || variation === void 0 ? void 0 : variation.isBoutiqueExclusive) ? false : !variation.selectable && !window.unshoppable && !props.boutiqueAvailability, selected: variation.value == props.currentId, isOutOfStock: variation.selectable, item: variation, onSelect: (variation) => {
                        props.onChangeVariation(variation);
                    }, onKeyDown: (e) => handleKeyDown(e, index), productUuid: props.productUuid, isNotAvailableSelectable: props.isNotAvailableSelectable, isBoutiqueExclusive: props.isBoutiqueExclusive },
                    React.createElement(ColorSwatch, { variation: variation, ariaHidden: true }),
                    !props.boutiqueAvailability && React.createElement("span", { className: "stroke" })));
            }))));
};
ProductSelectionColorExpandedLinks.defaultProps = {
    variationValues: [],
};
export default ProductSelectionColorExpandedLinks;
